import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isAuthenticated, getSession, logout } from "../utils/auth";
import OffCanvas from "./OffCanvas";
import LanguageSelector from "./LanguageSelector";

export default function Header() {
  const location = useLocation();
  const isSurveyRoute = location.pathname.startsWith("/survey");
  const isServicesRoute = location.pathname.startsWith("/services");
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const authed = isAuthenticated();
  const session = authed ? getSession() : null;

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    window.location.href = "/";
  };

  return (
    <>
      <header className="premium-header">
        <div className="header-inner">
          <div className="header-left">
            <Link to="/" className="header-logo">
              <img src="/assets/img/logo/logo-black.png" alt="Continental BioBank" className="header-logo-img" />
            </Link>
          </div>

          <nav className="header-nav">
            <Link to="/" className={`nav-link${location.pathname === "/" ? " active" : ""}`}>
              Home
            </Link>
            <Link to="/survey" className={`nav-link${isSurveyRoute ? " active" : ""}`}>
              Survey
            </Link>
            {authed && (
              <Link to="/services" className={`nav-link${isServicesRoute ? " active" : ""}`}>
                Services
              </Link>
            )}
            <div className="header-translate">
              <LanguageSelector />
            </div>
          </nav>

          <div className="header-right">
            {authed ? (
              <div className="header-auth">
                <span className="auth-greeting">Hello, {session.username}</span>
                <Link to="/dashboard" className="btn-header btn-outline">Dashboard</Link>
                {session?.isAdmin && <Link to="/admin/users" className="btn-header btn-outline">Users</Link>}
                <button onClick={handleLogout} className="btn-header btn-danger-sm">Logout</button>
              </div>
            ) : (
              <Link to="/login" className="btn-header btn-primary-sm">Login</Link>
            )}
            <Link to="/contact" className="btn-header btn-accent">
              Contact Us
              <svg width="16" height="10" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6.00071C16.4166 4.67142 11.9705 2.40252 9.21414 0L11.1357 5.31243H0.688756C0.552576 5.31246 0.419232 5.35209 0.305998 5.42773C0.192725 5.50341 0.104852 5.61172 0.0527125 5.73756C0.00064999 5.86334 -0.0134432 6.0016 0.0130924 6.13511C0.0396547 6.26871 0.105682 6.39175 0.201995 6.48809C0.330914 6.61703 0.505697 6.68939 0.688048 6.6897H11.135L9.21414 12C11.9701 9.59697 16.4165 7.32913 20 6.00071Z" fill="currentColor" />
              </svg>
            </Link>
            <button className="menu-toggle" onClick={() => setOffcanvasOpen(true)} aria-label="Open menu">
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </header>

      <OffCanvas isOpen={offcanvasOpen} onClose={() => setOffcanvasOpen(false)} />
    </>
  );
}
